import React from 'react';
import MenuItem from './MenuItem';
import { cn } from '@/lib/utils';

const menuItems = [
  { icon: "PersonalInfo", text: "Personal Info" },
  { icon: "Summary", text: "Summary" },
  { icon: "WorkExperience", text: "Work Experience" },
  { icon: "Education", text: "Education" },
  { icon: "Language", text: "Language" },
  { icon: "Certification", text: "Certification" },
  { icon: "Project", text: "Project" },
  { icon: "Skills", text: "Skills" },
  { icon: "Achievements", text: "Achievements" }
];

function Sidebar({ activeSection, onSectionClick }) {
  return (
    <>
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@latest/dist/tabler-icons.min.css" />
      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;700;800&family=Roboto:wght@400&display=swap" rel="stylesheet" />
      <div className={cn("w-52 bg-background rounded-2xl shadow-md p-11")}>
        <nav className={cn("flex flex-col gap-3.5")}>
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              icon={item.icon}
              text={item.text}
              isActive={activeSection === item.text}
              onClick={() => onSectionClick(item.text)}
            />
          ))}
        </nav>
      </div>
    </>
  );
}

export default Sidebar;